<app-main-layout [mainTemplateRef]="main" [requireLogin]="false">
  <ng-template #main>
    <main>
      <app-loader></app-loader>
    </main>
  </ng-template>
</app-main-layout>
